import { COLOR } from './colors';
import typography from './typography';
import shadows from './shadows';
export const buttonTheme = {
    MuiButton: {
        styleOverrides: {
            text: {
                padding: '10px 12px',
                height: '40px',
                minWidth: '56px',
            },
            outlined: {
                padding: '10px 20px',
                height: '40px',
                minWidth: '56px',
            },
            contained: {
                padding: '10px 20px',
                height: '40px',
                minWidth: '56px',
                boxShadow: shadows['6dp'],
            },
            label: Object.assign({}, typography.button),
            sizeSmall: {
                padding: '6px 16px',
                height: '32px',
                minWidth: '48px',
            },
            sizeLarge: {
                padding: '16px 24px',
                height: '48px',
                minWidth: '64px',
            },
            iconSizeSmall: {
                fontSize: '16px',
                '&> *:first-child': {
                    fontSize: '16px',
                },
            },
            iconSizeMedium: {
                fontSize: '24px',
                '&> *:first-child': {
                    fontSize: '16px',
                },
            },
            iconSizeLarge: {
                fontSize: '16px',
                '&> *:first-child': {
                    fontSize: '16px',
                },
            },
            containedPrimary: {
                color: COLOR.commonColor.white,
                boxShadow: shadows['2dp'],
                '&:disabled': {
                    color: COLOR.commonColor.white,
                    backgroundColor: COLOR.primaryGreyScale['200'],
                },
                '&:disabled:hover': {
                    color: COLOR.commonColor.white,
                    backgroundColor: COLOR.primaryGreyScale['200'],
                },
            },
            outlinedPrimary: {
                borderColor: COLOR.commonColor.primary,
                '&:disabled': {
                    color: COLOR.primaryGreyScale['200'],
                    backgroundColor: COLOR.commonColor.white,
                    borderColor: COLOR.primaryGreyScale['200'],
                },
            },
            textPrimary: {
                '&:hover': {
                    backgroundColor: COLOR.primaryGreyScale['50'],
                },
            },
            startIcon: {
                marginLeft: 0,
                marginRight: '8px',
                '&.MuiButton-iconSizeLarge': {
                    marginRight: '12px',
                },
            },
            endIcon: {
                marginRight: '0',
                marginLeft: '8px',
                '&.MuiButton-iconSizeLarge': {
                    marginLeft: '12px',
                },
            },
        },
    },
    MuiIconButton: {
        styleOverrides: {
            root: {
                '&:disabled': {
                    color: COLOR.textColor.tertiary,
                },
            },
        },
    },
    MuiButtonBase: {
        styleOverrides: {
            root: {
                '&:disabled': {
                    cursor: 'not-allowed',
                    pointerEvents: 'unset',
                },
            },
        },
    },
};
